import React,{Component} from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Modal } from "react-bootstrap";
import { validateUser,CreateUser } from '../../actions/userAction';
import { showHideModal,resetModalValues } from '../../actions/uiAction';
import { Control,Field } from 'react-redux-form';
import {mediaPath } from "../../config";


const userSchema=Yup.object().shape({
email: Yup.string()
	.email('Please enter a valid email address.')
	.trim()
	.max(254, 'Email must be at most 254 characters.')
	.required('Please enter your email address.'),
	user_password: Yup.string()
		.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, {
											message:'Please enter a valid password. Your password should contain an uppercase letter, a lowercase letter, a special character, a number and should contain a minimum of 8 characters.',
											excludeEmptyString: true
									})
		.trim().required('Please enter a password.'),
	cnf_password: Yup.string()
		.oneOf([Yup.ref('user_password'), null], 'The password and confirmation password do not match.'),
	first_name: Yup.string()
		.trim()
		.required('Please enter your first name.')
		.max(50, 'First name must be at most 50 characters long.')
		.matches(/^[^<>]*$/, 'First name must not contain HTML tags.')
		.matches(/^[A-Za-z\s'\-�]+$/, "First name can only contain letters, spaces, apostrophes, and hyphens."),

	last_name: Yup.string()
		.trim()
		.required('Please enter your last name.')
		.max(50, 'Last name must be at most 50 characters long.')
		.matches(/^[^<>]*$/, 'Last name must not contain HTML tags.')
		.matches(/^[A-Za-z\s'\-�]+$/, "Last name can only contain letters, spaces, apostrophes, and hyphens."),
		user_type: Yup.string()
		.trim().required('Please select whether or not you are an attorney or officer.'),
});

class createAccount extends Component {
	constructor(props, context) {
	super(props, context);
	props.resetModalValues("createAccount");

	this.state = {
	  show: false,
	  showBar : false,
	  ariaCheckedOfficer:false,
	  ariaCheckedAttorney:false,
	  ariaCheckedNeither:false,
	};
	
  }
  /* Function is used to display bar no. field based on the user type selected(if user_type is officer or attorney then only it will display) */
	showBarcode(e)
	{
		
	  if(e.currentTarget.value==='2')
	  {
		  this.setState({ showBar: false });
		  this.setState({ ariaCheckedOfficer: false });
		  this.setState({ ariaCheckedAttorney: false });
		  this.setState({ ariaCheckedNeither: true });
	  }else if(e.currentTarget.value==='0'){
		  this.setState({ showBar: true });
		  this.setState({ ariaCheckedOfficer: true });
		  this.setState({ ariaCheckedAttorney: false });
		  this.setState({ ariaCheckedNeither: false });
	  }else{
		this.setState({ showBar: true });
		this.setState({ ariaCheckedOfficer: false });
		this.setState({ ariaCheckedAttorney: true });
		this.setState({ ariaCheckedNeither: false });
	  }
	}
	/* Function is used to close the modal */
	handleClose() {
		this.props.showHideModal(false);
	}
	componentDidMount() {
		if(this.props.match.params.caseid!="" && this.props.match.params.caseid!=undefined){
			this.params =this.props.match.params;
		}
	}
	render(){
		return (
			<div className="create-account-block">
				<div className="header-wrapper" role="banner">
					<div className="header">
						<div className="container">
							<div className="col-xs-12">
								<a className="logo" onClick={()=>{
										this.props.history.push('/login');
									}}><img src={mediaPath+"osah-logo.png"} alt="Georgia Tax Court" /></a>
							</div>
						</div>
					</div>
				</div>
				<div className="create-account-wrapper" role="main">
					<div className="container">
						<h1>CREATE ACCOUNT</h1>
					</div>
					<div className="container">
						<div className="col-xs-6">
							<label aria-label="Email Address">Email Address*
								<Control.text type="email" aria-required="true" model="createAccount.email" value={this.props.createAccount.email.trim()}/>
							</label>
						</div>
					</div>
					<div className="container">
						<div className="col-xs-6">
							<label aria-label="Password">Password *
								<Control.password aria-required="true" aria-labelledby="Password" model="createAccount.user_password" value={this.props.createAccount.password}/>
							</label>
						</div>
						<div className="col-xs-6">
							<label aria-label="Confirm Password">Confirm Password *
								<Control.password aria-required="true" aria-labelledby="Confirm Password"  model="createAccount.cnf_password" value={this.props.createAccount.cnf_password}/>
							</label>
						</div>
						<div className="col-xs-6">
							<label aria-label="First Name">First Name *
								<Control.text aria-required="true" aria-labelledby="First Name" model="createAccount.first_name" value={this.props.createAccount.first_name}/>
							</label>
						</div>
						<div className="col-xs-6">
							<label aria-label="Last Name">Last Name *
								<Control.text aria-required="true" aria-labelledby="Last Name" model="createAccount.last_name" value={this.props.createAccount.last_name}/>
							</label>
						</div>
						<div className="col-xs-6 dropdown">
							<label aria-label="Are you an officer or attorney?">Are you an officer or attorney? *</label>
							<Field model="createAccount.user_type" >
								<div className="radio-block" role="radiogroup" tabIndex="0">
									<span>
										<input role="radio" aria-checked={this.state.ariaCheckedOfficer} id="officer" aria-label="Last Name"  name="doctype" type="radio" onChange = {(e)=>{
											this.showBarcode(e);}}  className="field radio" value="0" checked />
										<label className="" htmlFor="officer" >
											<span className="choice__text">Officer</span>
										</label>
									</span>
									<span>
										<input role="radio" aria-checked={this.state.ariaCheckedAttorney} id="attorney" aria-label="Attorney" name="doctype" type="radio" onChange = {(e)=>{
											this.showBarcode(e);}} className="field radio" value="1" />
										<label className="" htmlFor="attorney" >
											<span className="choice__text">Attorney</span>
										</label>
									</span>
									<span>
										<input role="radio" aria-checked={this.state.ariaCheckedNeither} id="neither" aria-label="Neither" name="doctype" type="radio" onChange = {(e)=>{
											this.showBarcode(e);}}  className="field radio" value="2" />
										<label className="" htmlFor="neither" >
											<span className="choice__text">Neither</span>
										</label>
									</span>							
								</div>
							</Field>
						</div>
						{this.state.showBar ? <div className="col-xs-6" >
							<label>{this.props.createAccount.user_type === '1' ? 'Bar #*' : 'Badge #*'}
								<Control.text  model="createAccount.bar_no" value={this.props.createAccount.bar_no || ''}/>
							</label>
						</div>:<div></div>}
					</div> 
				
				<div className="container">
					<div className="col-xs-12">
						<div className="btn-block create-account-btn">
							<button className="cancel-btn" onClick={()=>{
							this.props.history.push('/login');
							}} >Cancel</button>
							<button className="submit-btn" onClick={()=>{this.props.validateUser(this.props.createAccount,userSchema)}}>Submit</button>
						</div>
					</div>
				</div>
			</div>
			<Modal show={this.props.uiState.modalHideShow} 
                  onHide={()=>this.handleClose()} 
                  backdrop="static" id="find-case"
                  className="modal fade select-files">
                  <Modal.Header>
                    <button type="button" className="close" onClick={()=>this.handleClose()} ><img src={mediaPath+"close.png"} alt="close" /></button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
						<div className="col-xs-12">
								<p className="note">By clicking 'Accept', you are agreeing to receive notices of case information electronically.</p>
						</div>
					</div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="btn-block">
                      <button type="button" className="btn cancel" onClick={()=>this.handleClose()}>I Do Not Accept</button>
                      <button type="button" onClick={()=>{this.props.CreateUser(this.props.createAccount,this.params);this.handleClose()}} className="btn btn-default">I Accept</button>
                    </div>
                  </Modal.Footer>
                </Modal>
        </div>
			
		)
	}
}

function mapStateToProps(state) {
  return {
	  createAccount : state.createAccount,
	  uiState : state.uiState
  };
}

export default connect(mapStateToProps,{validateUser,showHideModal,CreateUser,resetModalValues})(createAccount);